<mat-toolbar class="subtitulo">Ocorrências de beneficiários</mat-toolbar>

<div class="painel-principal" style="padding: 10px;">
    <div class="painel-consultar">
        <form #formConsultar="ngForm">
            <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px" fxFlexFill>
                <div ngModelGroup="comboBeneficiario" fxFlex="50" fxLayoutGap="20px">
                    <combo-beneficiario [showDisplayId]="false" 
                                        [obrigatorio]="false" 
                                        [selecionado]="filtro.aluno"
                                        (valorChange)="onValorChange($event)">
                    </combo-beneficiario>
                </div>

                <div ngModelGroup="comboTipoOcorrenciaAluno" fxFlex="50%" fxLayoutGap="20px" fxFlexOffset="20px">
                    <combo-pesquisavel #comboTipoOcorrenciaAluno 
                                       nome="tipoOcorrenciaAluno" 
                                       [itens]="tiposOcorrenciasAluno" 
                                       itemDescricao="tipoOcorrencia"
                                       itemId="id"
                                       [showDisplayId]="false" 
                                       placeholder="Tipo de ocorrência"
                                       [obrigatorio]="false"
                                       [(valor)]="tipoOcorrenciaAluno">
                    </combo-pesquisavel>
                </div>
            </div>


            <div dir="rtl" class="botoes" fxLayoutGap="20px" style="padding-top: 20px; padding-bottom: 20px;" fxFlexFill>

                <button mat-raised-button fxFlex="20%" (click)="consultar()" [disabled]="formConsultar.invalid">
                    CONSULTAR
                </button>

                <button mat-raised-button fxFlex="20%" style="padding-right: 20px" (click)="limpar()" route>
                    LIMPAR
                </button>

            </div>
        </form>

        <table *ngIf="mostrarTabela; else tabelaSemDados" mat-table [dataSource]="dataSource" style="margin-top: 20px">

            <ng-container matColumnDef="nomeAluno">
                <th mat-header-cell *matHeaderCellDef style="width: 40%"> Beneficiário </th>
                <td mat-cell *matCellDef="let element"> {{element.aluno.pessoaFisica.nome}} </td>
            </ng-container>

            <ng-container matColumnDef="tipoOcorrencia">
                <th mat-header-cell *matHeaderCellDef> Tipo de Ocorrência </th>
                <td mat-cell *matCellDef="let element"> {{element.tipoOcorrenciaAluno.tipoOcorrencia}} </td>
            </ng-container>

            <ng-container matColumnDef="dataOcorrencia">
                <th mat-header-cell *matHeaderCellDef> Data da Ocorrência </th>
                <td mat-cell *matCellDef="let element"> {{element.dataOcorrencia | dataSimples}} </td>
            </ng-container>

            <ng-container matColumnDef="dataCiencia">
                <th mat-header-cell *matHeaderCellDef> Data da Ciência </th>
                <td mat-cell *matCellDef="let element"> {{element.dataCiencia | dataSimples}} </td>
            </ng-container>


            <ng-container matColumnDef="acoes">
                <th mat-header-cell *matHeaderCellDef> Ações </th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="perfilAcesso.deleta"  mat-button (click)="deletar(element)">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button *ngIf="perfilAcesso.consulta" mat-button (click)="atualizar(element)">
                        <mat-icon>search</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
        <div [hidden]="!mostrarTabela">
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
        </div>
        <ng-template #tabelaSemDados>
            <div fxLayout="row" fxLayoutAlign="center center" style="padding-top: 20px">
                {{msg}}
            </div>
        </ng-template>

        <div fxLayout="row" *ngIf="perfilAcesso.insere" fxLayoutAlign="end center" fxLayoutGap="16px" style="padding-top: 50px">
            <div>
                <button matTooltip="Adicionar nova ocorrência de beneficiário" mat-fab color="primary"
                    [routerLink]="['/ocorrenciaaluno/cadastrar']" routerLinkActive="router-link-active">
                    <mat-icon>add</mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
